import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IShareAction } from '../../../../ts/ServerApi/types/actionNames';
import { shareContent } from '../../../actions/spaces/ShareContentAction';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { allCollection, allRecommendedView,anyItemIsEmbeddedDatasource, isSingleUnpublishedFlowDraft, isSingleUnShareableCollection } from './IEntityActionHelpers';

export const ShareContentAction: IEntityAction<IContentInfo, IShareAction> = {
  name: EntityActionNames.ShareContent,
  translateName: Messages.share_content_action,
  isVisible: (targetItems: IContentInfo[], appState: AppState) => {
    return FeatureFlags.newShareDialogEnabled && !anyItemIsEmbeddedDatasource(targetItems)
      && !isSingleUnpublishedFlowDraft(targetItems) && !isSingleUnShareableCollection(appState, targetItems);
  },
  isClickable: (availableActions: IShareAction, targetItems: IContentInfo[], state: AppState) => {
    return (availableActions && availableActions.share) || allCollection(targetItems) || allRecommendedView(targetItems);
  },
  createReduxAction: (targetItems: IContentInfo[]) => {
    return shareContent(targetItems[0]);
  }
};
